import AvailabilitesLayout from "./AvailabilitesLayout";
export default AvailabilitesLayout